(function(){
  var d=document.querySelector('.rs-last'); if(!d) return;
  var unit=parseInt(d.dataset.unit,10)||0, maxq=parseInt(d.dataset.maxq,10)||1, cur=d.dataset.cur||'EUR', loc=d.dataset.loc||'fr', design=d.dataset.design==='true';
  function fmt(c){try{return (c/100).toLocaleString(loc,{style:'currency',currency:cur})}catch(e){return (c/100).toFixed(2)+' '+cur}}
  var form=document.querySelector('.rs-form');
  if(form){
    var inp=form.querySelector('input'), tot=form.querySelector('.rs-total');
    form.querySelectorAll('[data-q]').forEach(function(b){
      b.addEventListener('click',function(){
        var q=Math.min(maxq,Math.max(1,(parseInt(inp.value,10)||1)+parseInt(b.dataset.q,10)));
        inp.value=q; tot.textContent=fmt(unit*q);
      });
    });
    form.addEventListener('submit',function(e){
      e.preventDefault();
      window.location.href=form.getAttribute('action')+'/'+form.dataset.variant+':'+(parseInt(inp.value,10)||1);
    });
  }
  var st=document.getElementById('rs-sticky'), buy=document.getElementById('rs-buy');
  if(st&&buy&&'IntersectionObserver' in window){
    new IntersectionObserver(function(es){es.forEach(function(e){st.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0)})}).observe(buy);
  } else if(st){st.classList.add('is-on')}
  var rv=document.querySelectorAll('.rs .rs-reveal');
  if(!('IntersectionObserver' in window)||design){rv.forEach(function(el){el.classList.add('is-in')});return;}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
  rv.forEach(function(el,i){el.style.transitionDelay=((i%3)*80)+'ms';io.observe(el)});
})();